import * as React from "react";
import { george, ui, pr, theme } from "aaa";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { observer } from "mobx-react";
import { BSPOptionsStore } from "../BSPOptionsStore";
import * as moment from "moment";
import { config } from "config";

export const BSPOptionsSummarySection = observer(({ store, style }: { store: BSPOptionsStore, style?: React.CSSProperties }) => {
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    const summaryElementStyles = isMobile
        ? {
            elementStyle: {
                fontSize: 16,
                lineHeight: "24px"
            },
            labelStyle: {
                fontSize: 14,
                lineHeight: "20px",
            }
        }
        : {
            elementStyle: {
                fontSize: 16,
                lineHeight: "24px",
                width: "50%"
            },
            labelStyle: {
                fontSize: 14,
                lineHeight: "20px",
                width: "50%"
            }
        };

    const summaryElementLabelStyle = {
        alignItems: "center",
        margin: "unset",
        padding: 10,
        borderRadius: 4,
    };

    const summaryElementBackgroundStyle = {
        ...summaryElementLabelStyle,
        backgroundColor: ui.isDarkMode ? "#3A3A3C" : "#EFF1F5",
    };

    const contractHolders = store.prolongationDetails?.customerDetails.filter(customer => customer.customerRoleCode === "VI") ?? [];
    const contractAdditionalHolders = store.prolongationDetails?.customerDetails.filter(customer => customer.customerRoleCode === "WVI") ?? [];
    const allContractHolders = contractHolders.concat(contractAdditionalHolders);

    const contractHolderLegalGuardians = store.prolongationDetails?.customerDetails.filter(customer => customer.customerRoleCode === "GV") ?? [];

    const hasLegalGuardians = contractHolderLegalGuardians.length > 0;

    return (
        <div style={style}>
            <pr.P_18_TITLE style={{ fontWeight: 700, lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                {ui.__("bspOptions.summary.title")}
            </pr.P_18_TITLE>
            <div style={{ marginTop: 8 }}>
                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.contractNumber")}
                    style={summaryElementBackgroundStyle}
                    {...summaryElementStyles}
                >
                    <pr.SigningLabel>
                        {store.buildingsAccount?.id}
                    </pr.SigningLabel>
                </george.ResponsiveSummaryElement>
                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.contractOwner")}
                    style={summaryElementLabelStyle}
                    {...summaryElementStyles}
                >
                    {allContractHolders.map(contractHolder => (
                        <pr.SigningLabel>
                            {contractHolder?.firstName} {contractHolder?.lastName}
                        </pr.SigningLabel>
                    ))}
                </george.ResponsiveSummaryElement>
                {hasLegalGuardians && (
                    <george.ResponsiveSummaryElement
                        label={ui.__("bspOptions.summary.legalRepresentative")}
                        style={summaryElementBackgroundStyle}
                        {...summaryElementStyles}
                    >
                        {contractHolderLegalGuardians.map(contractHolderLegalGuardian => (
                            <pr.SigningLabel>
                                {contractHolderLegalGuardian?.firstName} {contractHolderLegalGuardian.lastName}
                            </pr.SigningLabel>
                        ))}
                    </george.ResponsiveSummaryElement>
                )}
                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.prolongationStartDate")}
                    style={hasLegalGuardians ? summaryElementLabelStyle : summaryElementBackgroundStyle}
                    {...summaryElementStyles}
                >
                    <pr.SigningLabel>
                        {moment(store.prolongationDetails?.startDate).format("DD.MM.YYYY")}
                    </pr.SigningLabel>
                </george.ResponsiveSummaryElement>
                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.prolongationEndDate")}
                    style={hasLegalGuardians ? summaryElementBackgroundStyle : summaryElementLabelStyle}
                    {...summaryElementStyles}
                >
                    <pr.SigningLabel>
                        {moment(store.prolongationDetails?.endDate).format("DD.MM.YYYY")}
                    </pr.SigningLabel>
                </george.ResponsiveSummaryElement>
                <george.ResponsiveSummaryElement
                    label={ui.__("bspOptions.summary.annualInterestRate")}
                    style={hasLegalGuardians ? summaryElementLabelStyle : summaryElementBackgroundStyle}
                    {...summaryElementStyles}
                >
                    <pr.SigningLabel>
                        {store.prolongationDetails?.interestRate.replace(".", config.CURRENCY_DECIMAL_SEPARATOR)} %
                    </pr.SigningLabel>
                </george.ResponsiveSummaryElement>
            </div>
        </div>
    );
});


// WEBPACK FOOTER //
// ./src/components/BSPOptions/components/BSPOptionsSummarySection.tsx